var map = {
	"./cnn-money-x2.png": 2061,
	"./cnn-money.png": 2274,
	"./economist-x2.png": 2062,
	"./economist.png": 2275,
	"./mashable-x2.png": 2063,
	"./mashable.png": 2276,
	"./tech-crunch-x2.png": 2064,
	"./tech-crunch.png": 2277,
	"./thenewyorker-x2.png": 2065,
	"./thenewyorker.png": 2278,
	"./thrillist-x2.png": 2066,
	"./thrillist.png": 2279,
	"./time-x2.png": 2067,
	"./time.png": 2280,
	"./usa-today-x2.png": 2068,
	"./usa-today.png": 2281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2273;